"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const emojilib_1 = __importDefault(require("emojilib"));
const match_sorter_1 = require("match-sorter");
/* build proper library with included name of the emoji */
const library = Object.entries(emojilib_1.default).map(([name, emojiObject]) => {
    return {
        keywords: [name, ...emojiObject],
        name,
    };
});
function searchEmoji(key) {
    return (0, match_sorter_1.matchSorter)(library, key, { keys: ["keywords"] });
}
exports.default = searchEmoji;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSx3REFBMkI7QUFDM0IsK0NBQTJDO0FBRTNDLDBEQUEwRDtBQUMxRCxNQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsT0FBTyxDQUFDLGtCQUFHLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLElBQUksRUFBRSxXQUFXLENBQUMsRUFBRSxFQUFFO0lBQzlELE9BQU87UUFDTCxRQUFRLEVBQUUsQ0FBQyxJQUFJLEVBQUUsR0FBRyxXQUFXLENBQUM7UUFDaEMsSUFBSTtLQUNMLENBQUM7QUFDSixDQUFDLENBQUMsQ0FBQztBQUVILFNBQVMsV0FBVyxDQUFDLEdBQVc7SUFDOUIsT0FBTyxJQUFBLDBCQUFXLEVBQUMsT0FBTyxFQUFFLEdBQUcsRUFBRSxFQUFFLElBQUksRUFBRSxDQUFDLFVBQVUsQ0FBQyxFQUFFLENBQUMsQ0FBQztBQUMzRCxDQUFDO0FBRUQsa0JBQWUsV0FBVyxDQUFDIn0=